/** Betragseingabe einer Person: `euro` (10 = 10,00) oder `cents` (wie DATEV: 1000 = 10,00). Nur für Geldbeträge. */
export type AmountEntry = "euro" | "cents";

export type UnitsSettings = {
  /** BCP 47 locale, e.g. "de-DE", "en-US". Null/empty => default locale. */
  locale?: string | null;
  /** BCP 47 locale for number formatting. Null/empty => locale. */
  numberLocale?: string | null;
  /** IANA timezone, e.g. "Europe/Berlin". Null/empty => default timezone. */
  timeZone?: string | null;
  /** ISO 4217 currency, e.g. "EUR". Null/empty => default currency. */
  currency?: string | null;
  /** Legacy/DTO alias for currency. Prefer currency in new code. */
  currencyCode?: string | null;
  /** Day.js-style date format from unit settings, e.g. "DD.MM.YYYY". */
  dateFormat?: string | null;
  /** Betragseingabe für Geldfelder (`MoneyField`). Null/leer => `euro`. */
  amountEntry?: AmountEntry | null;
  /** Addressing style used by document/template features. */
  addressing?: string | null;
};

export const defaultUnitsSettings: UnitsSettings = {
  locale: null,
  numberLocale: null,
  timeZone: null,
  currency: null,
  addressing: "Du",
};
